import {Component, Input, OnInit} from '@angular/core';

interface ITab  {
  path: string;
  label: string;
  info?: string;
}

/*
  For content use slot=content, example: <router-outlet slot="content"></router-outlet>
  For buttons use slot=buttons, example: <div slot="buttons"><button>button</button></div>
 */

@Component({
  selector: 'app-page-tabs',
  templateUrl: './page-tabs.component.html',
  styleUrls: ['./page-tabs.component.scss']
})
export class PageTabsComponent implements OnInit {

  @Input() tabs: ITab[];
  @Input() noBorder: boolean;

  constructor() {}

  ngOnInit(): void {
  }

}
